import { gql } from '@apollo/client';
const GET_CURRENT_TENANT = gql `
  query GetCurrentTenant {
    me {
      id
      currentTenant {
        id
        defaultCurrency {
          id
          isoCode
          name
        }
        rootFolder {
          id
        }
      }
      tenants {
        edges {
          node {
            id
            provisioningStatus
          }
        }
      }
    }
  }
`;
export default GET_CURRENT_TENANT;
